import { render, staticRenderFns } from "./PhonesFilters.vue?vue&type=template&id=41f29dca&scoped=true"
import script from "./PhonesFilters.vue?vue&type=script&lang=ts"
export * from "./PhonesFilters.vue?vue&type=script&lang=ts"
import style0 from "./PhonesFilters.vue?vue&type=style&index=0&id=41f29dca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f29dca",
  null
  
)

export default component.exports